export const loginAPI = "/account/login";

export const roleBasedAPI = "/account";
